import * as React from "react";
import { IBillingDetail } from "@nkr/models/index";
import { BillableNephrectomyStatus } from "@nkr/enums/index";

interface IProps {
    data: IBillingDetail
}

class ListRow extends React.Component<IProps, {}> {
    render = () => {
        const disabledButtons = this.props.data.billableNephrectomy.id == 0 || this.props.data.billableNephrectomy.statusId == BillableNephrectomyStatus.PendingDataEntry;
        const item = this.props.data;

        return (
            <tr>
                <td>{item.billableNephrectomy.surgeryDate}</td>
                <td>{item.billableNephrectomy.chainId}/{item.billableNephrectomy.clusterNumber}/{item.billableNephrectomy.positionNumber}</td>
                <td>{item.billableNephrectomy.donor.center.alias} {item.billableNephrectomy.donor.rdnCenterId > 0 ? <span style={{color: 'darkred'}}>({item.billableNephrectomy.donor.rdnCenterAlias})</span> : null}</td>
                <td>{item.billableNephrectomy.donor.alias}</td>
                <td>{item.billableNephrectomy.recipient.center.alias}</td>
                <td>{item.billableNephrectomy.recipient.alias}</td>
                <td>{item.claimType}</td>
                <td></td>
            </tr>
        );
    }
}

export default ListRow;